import { useEffect} from "react";
import { StatusbarComponent } from './statusbar';
import Nav from '../pages/Nav';
import { format } from "date-fns";

const NotificationViewComponent = ({ notifications, setNotifications, search, setSearch }) => {
    useEffect(function() {
        const eventSource = new EventSource("https://www.vdlsoft.nl/api/v1/notifications/emit");

        eventSource.addEventListener("notifications", (event) => {
            const data = JSON.parse(event.data);
            setNotifications(data);
        });

        eventSource.onerror = (err) => {
            console.error("SSE error:", err);
            eventSource.close();
        };

        // cleanup on unmount
        return () => {
            eventSource.close();
        };
    });

    return (
        <>
            <StatusbarComponent />
            <Nav search={search} setSearch={setSearch} />
            <table id="table1" className="table">
                <thead id="thead1">
                    <tr id="tr-0">
                        <th id="th-0-1">Date/Time</th>
                        <th id="th-0-2">Type</th>
                        <th id="th-0-3">Notification</th>
                    </tr>
                </thead>
                <tbody id="tbody1">
                    {notifications.map((notification) => {
                    let rowId = `tr-${notification.id}`;
                    let tdId1 = `td-${notification.id}-1`;
                    let tdId2 = `td-${notification.id}-2`;
                    let tdId3 = `td-${notification.id}-3`;
                    let displayDate = new Date(notification.created_at);
                    displayDate = format(displayDate,"dd-MM-yyyy HH:mm:ss");
            
                    return (
                        <tr key={rowId} id={rowId} className="table-warning">
                            <td id={tdId1} style={{width: '15%'}}>{displayDate}</td>
                            <td id={tdId2} style={{width: '8%'}}>{notification.notificationType}</td>
                            <td id={tdId3}>{notification.notificationText}</td>
                        </tr>
                    );
                    })}   
                </tbody>
            </table>
    </>
    )
}

export { NotificationViewComponent };